module.exports = __webpack_public_path__ + "img/chefs.adc28034.svg";